import { render, staticRenderFns } from "./PropertySearch.vue?vue&type=template&id=6c8c80de"
import script from "./PropertySearch.vue?vue&type=script&lang=js"
export * from "./PropertySearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports